import { Drawer, List } from '@material-ui/core';
import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError } from 'axios';
import { HomeIcon } from 'components/Icons';
import { MainRoutePath } from 'library/Routes';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssessorActionsLoadEventoList } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorEventList, IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { assembleiasAssociadoActionsLoadAll } from 'store/modules/AssembleiasAssociadoActions';
import { IAssembleiaAssociado, IAssembleiasAssociadoReducer } from 'store/modules/AssembleiasAssociadoReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { LEFT_MENU_ACTIONS_CLOSE } from 'store/modules/LeftMenuActionTypes';
import { ILeftMenuReducer } from 'store/modules/LeftMenuReducer';
import { IReducer } from 'store/Reducer';
import { isAssociadoProfile } from 'utils/AuthUtils';
import AssessorMenu from './Assessor';
import AssociadoMenu from './Associado';
import { Item, Subheader } from './components';
import useStyle from './style';

interface Props {
  usuario?: IAuthUserReducer;
  assembleiasAssociado?: IAssembleiasAssociadoReducer;
  assembleiasAssessor?: IAssembleiasAssessorReducer;
  leftMenu?: ILeftMenuReducer;
  assembleiasAssociadoActionsLoadAll: (
    callbackSuccess?: (all: IAssembleiaAssociado[]) => void,
    callbackError?: (error: AxiosError<ErrorAPI>) => void
    ) => void;
  assembleiasAssessorActionsLoadEventoList: (
    callbackSuccess: (all: IAssembleiasAssessorEventList[]) => void,
    callbackError?: (error: AxiosError<ErrorAPI>) => void
    ) => void;
}

const mapStateToProps = (state: IReducer) => {
  return {
    usuario: state.auth.usuario,
    assembleiasAssociado: state.assembleias,
    assembleiasAssessor: state.assembleiasAssessor,
    leftMenu: state.leftMenu,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      assembleiasAssociadoActionsLoadAll,
      assembleiasAssessorActionsLoadEventoList,
    },
    dispatch
  );

function LeftMenu({
  usuario,
  assembleiasAssessor,
  assembleiasAssociado,
  assembleiasAssociadoActionsLoadAll,
  assembleiasAssessorActionsLoadEventoList,
  leftMenu,
}: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyle();

  const leftMenuActionsClose = useCallback(() => {
    if (leftMenu?.opened) {
      dispatch({ type: LEFT_MENU_ACTIONS_CLOSE });
    }
  }, [dispatch, leftMenu]);

  return (
    <Drawer
      anchor="left"
      variant="temporary"
      open={leftMenu?.opened}
      onClose={leftMenuActionsClose}
      className={classes.drawer}
    >
      <List component="nav" subheader={<Subheader />}>
        <Item path={MainRoutePath} text={t('LeftMenu.home')} icon={<HomeIcon />} closeMenu={leftMenuActionsClose} />
        {usuario && isAssociadoProfile(usuario.perfil) && (
          <AssociadoMenu
            assembleias={assembleiasAssociado}
            loader={assembleiasAssociadoActionsLoadAll}
            closeMenu={leftMenuActionsClose}
            needLoad={assembleiasAssociado?.needLoadAll || false}
          />
        )}
        {usuario && !isAssociadoProfile(usuario.perfil) && (
          <AssessorMenu
            assembleias={assembleiasAssessor}
            loader={assembleiasAssessorActionsLoadEventoList}
            closeMenu={leftMenuActionsClose}
            needLoad={assembleiasAssessor?.needLoadListaEvento || false}
          />
        )}
      </List>
    </Drawer>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenu);